/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MiddleName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MiddleName({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content/Content/SimilarPerson/Person/Details/Content/MiddleName"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let similarPersonMiddleNameValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'middle_name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="MiddleName.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1nRIf4': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Middle Name"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="similar_person.middle_name"
 text={similarPersonMiddleNameValueData}
/>
</div>
{children}
</React.Fragment>)
}